// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as PlaceOrderData from "../../app/entity/PlaceOrderData.bs.js";

function defaultValue_dispatch(param) {
  
}

var defaultValue = {
  state: PlaceOrderData.initialState,
  dispatch: defaultValue_dispatch
};

var context = React.createContext(defaultValue);

function useContext(param) {
  return React.useContext(context);
}

export {
  defaultValue ,
  context ,
  useContext ,
  
}
/* context Not a pure module */
